import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 1100px;
  width: 100%;
`;
